export const MAX_PRODUCT_OPTIONS = 3
export const MAX_PRODUCT_VARIANTS = 100
